
import Vue from 'vue'
import {Action, Getter, namespace} from 'vuex-class'
import {Component} from 'vue-property-decorator'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'

const uiModule = namespace('ui')
const authModule = namespace('auth')

@Component({
  mixins: [validationMixin],
  validations: {
    form: {
      NOM_UTILISATEUR: {
        required
      },
      MOT_DE_PASSE: {
        required
      }
    }
  }
})
export default class App extends Vue {
  @uiModule.Getter('isLoadingGetter') isLoading: any
  @authModule.Action('loginAction') login: any

  $refs!: {
    nomUtilisateur: HTMLFormElement
  }

  form: any = {
    NOM_UTILISATEUR: '',
    MOT_DE_PASSE: ''
  }

  mounted() {
    this.$refs.nomUtilisateur.focus()
  }

  submitForm() {
    this.$v.$touch()
    if (!this.$v.$invalid) {
      this.login({
        formParams: this.form,
        queryParams: null
      })
    }
  }
}
